// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"a5226424","235":"7db6e5cd","250":"80212e2d","267":"136ae8ed","370":"c8919f09","488":"0cb40a7f","553":"98391d52","667":"20ecb0c2","695":"25690472","806":"b545ecef","849":"22b5e2bf","887":"3a4c62ec","921":"7569af01","928":"cbe12117","977":"e0603150","987":"68126272"}[chunkId] + ".chunk.js";
};